import { Col, Form, FormFeedback, Input, Label, Row, Tooltip } from "reactstrap";
import { ChooseYourCurrency, InitialCost, ProductStocks, SellingPriceText, TypesOfProductDiscount } from "../../../../../constants";
import { useAppDispatch, useAppSelector } from "../../../../../reduxToolkit/hooks";
import { setFormValue } from "../../../../../reduxToolkit/reducers/eCommerce/addProductSlice";
import { CurrencyList, TypesOfProductList } from "../../../../../data/applications/ECommerce";
import { useState } from "react";


// This component handles the pricing details input for adding a product.
const Pricing = () => {
  const dispatch = useAppDispatch();
    const { formValue } = useAppSelector((state) => state.addProduct);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);

  return (
    <div className="sidebar-body">
      <Form className="price-wrapper">
        <Row className="g-3 custom-input">
          <Col sm="6">
            <Label>
              {InitialCost}
              <span className="text-danger">*</span>
            </Label>
            <Input className={formValue.initialCost !== "" ? "is-valid" : "is-invalid"} type="number" name="initialCost" onChange={(e) => dispatch(setFormValue({ name: "initialCost", value: e.target.value }))} />
            <FormFeedback>An initial cost is required</FormFeedback>
          </Col>
          <Col sm="6">
            <Label>
              {SellingPriceText} <span className="text-danger">*</span>
            </Label>
            <Input className={formValue.initialPrice !== "" ? "is-valid" : "is-invalid"} type="number" name="initialPrice" onChange={(e) => dispatch(setFormValue({ name: "initialPrice", value: e.target.value }))} />
            <FormFeedback>An initial price is required</FormFeedback>
          </Col>
          <Col sm="6">
            <Label>{ChooseYourCurrency}</Label>
            <Input type="select" defaultValue={"Dollar $"} name="select" onChange={(e) => dispatch(setFormValue({ name: "select", value: e.target.value }))}>
              {CurrencyList.map((item, index) => (
                <option key={index}>{item}</option>
              ))}
            </Input>
          </Col>
          <Col sm="6">
            <Label>
              {ProductStocks}
              <span className="text-danger">*</span>
            </Label>
            <Input className={formValue.productStocks !== "" ? "is-valid" : "is-invalid"} type="number" name="productStocks" onChange={(e) => dispatch(setFormValue({ name: "productStocks", value: e.target.value }))} />
            <FormFeedback>Product stocks value is required</FormFeedback>
          </Col>
          <Col xs="12">
            <Label for="exampleFormControlInput1">
              {TypesOfProductDiscount}
              <i className="icon-help-alt ms-1" id="tooltip1" />
              <Tooltip target="tooltip1" placement="top" toggle={toggle} isOpen={tooltipOpen}>
                {"Choose the kind of discount that will be used on that particular item."}
              </Tooltip>
            </Label>
            <ul className="radio-wrapper">
              {/* Mapping through TypesOfProductList to dynamically render radio icons */}
              {TypesOfProductList.map((data, i) => (
                <li key={i}>
                  <Input id={data.id} type="radio" name="radio5" defaultValue="option5" />
                  <Label htmlFor={data.id} check>
                    <span>{data.title}</span>
                  </Label>
                </li>
              ))}
            </ul>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default Pricing;